import { VerticalAlignTopOutlined } from '@ant-design/icons';
import { FloatButton } from 'antd';
import { useIntl } from 'umi';

/** Page content is inset 40px (PageContainer); the button has to fit inside that margin. */
const BUTTON_SIZE = 36;

/**
 * Floating "back to top" button for every admin page that scrolls.
 * Stays hidden until the page has been scrolled down.
 * It sits in the right page margin, so it never covers the pagination or the
 * action column of a table, and high enough to stay clear of the pagination row
 * when the page is scrolled to its end.
 */
const ScrollToTopButton: React.FC = () => {
  const intl = useIntl();
  const label = intl.formatMessage({ id: 'component.scrollToTop.label' });

  return (
    <FloatButton.BackTop
      type="primary"
      icon={<VerticalAlignTopOutlined />}
      // The default tooltip sits above the button, centred, and so gets pushed against the
      // window edge: it lands a pixel past it, the page grows a horizontal scrollbar, the
      // viewport shrinks and the button jumps under the cursor. To the left there is room.
      tooltip={{ title: label, placement: 'left' }}
      aria-label={label}
      visibilityHeight={100}
      duration={200}
      style={{
        width: BUTTON_SIZE,
        height: BUTTON_SIZE,
        insetInlineEnd: 2,
        insetBlockEnd: 96,
        // Above page content (sticky table headers), below every modal, drawer and overlay.
        zIndex: 100,
      }}
    />
  );
};

export default ScrollToTopButton;
